import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDebounce } from 'use-debounce';
import { apiService } from '../../../../services/ApiService';
import Autocomplete from '../../../../components/Inputs/Autocomplete/Autocomplete';

const PartnerInput = ({
  isDisabled,
  isValid,
  onChange,
  wrapperProps,
  initialInputValue,
  value,
}) => {
  const [inputValue, setInputValue] = useState(initialInputValue);

  const [selectedOption, setSelectedOption] = useState(() => {
    return initialInputValue && value
      ? { label: initialInputValue, value }
      : undefined;
  });

  useEffect(() => {
    if (!selectedOption && initialInputValue && value) {
      setSelectedOption({ label: initialInputValue, value });
    }
  }, [selectedOption, initialInputValue, value]);

  const [debouncedInputValue] = useDebounce(inputValue, 500);

  const { data: partners, isLoading } = useQuery({
    queryKey: ['partners-autocomplete', debouncedInputValue],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      let data = {
        limit: 70,
        ...(debouncedInputValue?.length > 0 && { search: debouncedInputValue }),
      };

      return await apiService.getPartners(data);
    },
  });

  const PartnerOptions =
    partners?.data?.map((terminal) => ({
      label: terminal.name,
      value: terminal.id,
    })) || [];

  return (
    <Autocomplete
      isValid={isValid}
      isDisabled={isDisabled}
      options={PartnerOptions}
      isLoading={isLoading}
      setInputValue={setInputValue}
      onChange={onChange}
      inputValue={inputValue}
      setSelectedOption={setSelectedOption}
      selectedOption={selectedOption}
      wrapperProps={wrapperProps}
      placeholder="Select Partner"
    />
  );
};

export default PartnerInput;
